export default __webpack_public_path__ + "static/media/5324.13155a23.png";